import { gql } from "@/__generated__/gql";

export const INTERESTS = gql(`
  query Interests(
    $first: Int
    $after: String
  ) {
    interests(first: $first, after: $after) {
      edges {
        node {
          name
          id
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`);
